import { type Program } from '@/shared/types/program.type'

import { type TranslatableText } from '../../../types/TranslatableText.type'
import { type Genre, type MusicGroup } from './musicGroup/musicGroup.type'
import { type Scene } from './scene.type'

type StringDate = string

export type ProgEvent = {
  _id: string
  copyright?: string | null
  day: StringDate
  descriptions?: TranslatableText | null
  lineUp?: TranslatableText | null
  enableAttending: boolean
  enableRating: boolean
  eventAttendeesList: EventAttendeesDTO[]
  eventTicketLink?: string | null
  genres: string[] | null
  hideEndDate: boolean
  hideLocation: boolean
  image?: string | null
  isVisible: boolean
  meanRate: number
  musicGroups?: MusicGroup[]
  /**
   * When set, this event is a sub-slot of the referenced parent: it stops being listed anywhere and
   * only carries the schedule of its guests inside the parent's time range.
   */
  parentEventId?: string | null
  notifPlanned: boolean
  prices?: TranslatableText | null
  program: Program
  programEventNotifSendTime: ProgramEventNotifSendTime
  scene: Scene
  showEndDate?: StringDate
  showStartDate?: StringDate
  soldOut: boolean
  tags?: Genre[]
  keepGuestTags: boolean | null
  ticketOpenInWebview: boolean
  titles?: TranslatableText | null

  //computed fields
  startTime: `${number}:${number}`
  endTime: `${number}:${number}`
  fakeTitle: string
  date: string
  attendees: number
  // Optional freeze flag used by the import-feature UI toggle.
  freeze?: boolean
}

export type EventAttendeesDTO = {
  deviceUUID: string
  firebaseUserId: string
  comment: string
  rate: number | null
}

export enum ProgramEventNotifSendTime {
  _10M_AFTER = '_10M_AFTER',
  NEXT_DAY_AT_10 = 'NEXT_DAY_AT_10',
  NEVER = 'NEVER',
}
